declare var spreadsheet: any;

namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    export class DataReportViewGrid extends Serenity.DataGrid<any, DataReportViewGridOptions> {
        protected getDialogType() { return DataReportsDialog; }
        protected getIdProperty() { return "__$index"; }
        protected getLocalTextPrefix() { return DataReportsRow.localTextPrefix; }

        private paramsGrid: Serenity.PropertyGrid;
        private paramsValidator: JQueryValidation.Validator;
        private favoriteView: string;
        private autoRun: boolean;
        private noRecordsMessage: JQuery;
        private autoColumnWidth: Serenity.AutoColumnWidthMixin;
        private autoSizingColumns: number = 0;
        private groupItemMetadataProvider: Serenity.GroupSumsMetadataProvider;

        constructor(container: JQuery, opt: DataReportViewGridOptions) {
            super(container, opt);

            this.element.find('.slick-grouping-panel, .slick-footerrow').off('scroll');

            new Serenity.FavoriteViewsMixin({
                grid: this
            });

            new Serenity.HeaderFiltersMixin({
                grid: this
            });

            this.view.onAjaxCall = (s, o) => {

                this.noRecordsMessage && this.noRecordsMessage.hide();

                this.slickContainer.block({
                    message: '<div class="grid-loading-spinner"><i class="fa fa-spinner fa-spin"></i> Loading, please wait...</div>',
                    css: {
                        border: 'none',
                        background: 'transparent'
                    },
                    fadeOut: 0,
                    showOverlay: false
                });

                var oldSuccess = o.success;
                o.success = (d, t, x) => {
                    (this.slickContainer as any).unblock();

                    if (d && d.Entities && d.Entities.length == 0) {
                        if (!this.noRecordsMessage) {
                            this.noRecordsMessage = $('<h3/>').appendTo(this.slickContainer.find('.slick-viewport')).css({
                                position: 'absolute',
                                top: '40%',
                                left: 0,
                                right: 0,
                                textAlign: 'center',
                                color: 'palevioletred'
                            }).text('No data for current selection');
                        }
                        else
                            this.noRecordsMessage.show();
                    }

                    oldSuccess && oldSuccess(d, t, x);
                };

                var oldError = o.error;
                o.error = (x, t, e) => {
                    (this.slickContainer as any).unblock();
                    oldError && oldError(x, t, e);
                };

                return true;
            };

            var autoColumnWidthOptions = this.getAutoColumnWidthOptions();
            if (autoColumnWidthOptions != null) {
                this.autoColumnWidth = new Serenity.AutoColumnWidthMixin(autoColumnWidthOptions);
                this.autoSizeColumns();
                this.slickGrid.onColumnsResized.subscribe(() => {
                    if (!this.autoSizingColumns)
                        this._disableAutoSizeColumns = true;
                });
            }

            $('div.favorite-views', this.element).css({
                'margin-left': 'auto',
                'margin-right': '8px'
            }).appendTo(this.toolbar.element);
            this.toolbar.element.find('.params-toggle').appendTo(this.toolbar.element);

            if (this.options.description && this.options.description != this.options.title) {
                $("<div class='report-description'/>")
                    .text(this.options.description || '')
                    .css({
                        'width': '100%'
                    }).appendTo(this.toolbar.element);
            }

            $(window).on('layout.' + this.uniqueName, resizeSpreadsheet);
        }

        destroy() {
            $(window).off('.' + this.uniqueName)
            super.destroy();
        }

        protected getAutoColumnWidthOptions(): Serenity.AutoColumnWidthMixinOptions {
            return {
                grid: this,
                useExplicitWidths: () => this._disableAutoSizeColumns == null,
                maxRows: 100,
                maxWidth: 400,
                minWidth: 30,
                beforeUserAutoSizeAll: () => this._disableAutoSizeColumns = false,
                afterUserAutoSizeAll: () => this._disableAutoSizeColumns = false
            };
        }

        protected loadParams(source: any) {
            this.paramsGrid && this.paramsGrid.load(source);
        }

        protected _disableAutoSizeColumns: boolean;

        protected autoSizeColumns() {
            if (this._disableAutoSizeColumns)
                return;

            Serenity.LazyLoadHelper.executeOnceWhenShown(this.element, () => {
                this.autoSizingColumns++;
                try {
                    this.autoColumnWidth && this.autoColumnWidth.autoSizeAllColumns();
                }
                finally {
                    this.autoSizingColumns--;
                }
            });
        }

        protected persistSettings(flags?: Serenity.GridPersistanceFlags) {
            if (this.autoSizingColumns)
                return;

            super.persistSettings(flags);
        }

        protected getPersistanceStorage() {
            return new Common.UserPreferenceStorage();
        }

        protected getCurrentSettings(flags?: Serenity.GridPersistanceFlags): Serenity.PersistedGridSettings {
            flags = flags || this.gridPersistanceFlags();
            flags.columnWidths = Q.coalesce(flags.columnWidths, !!this._disableAutoSizeColumns);
            var settings = super.getCurrentSettings(flags);
            var prm = {};
            this.paramsGrid.save(prm);
            settings['params'] = prm;
            var grouping = (this.view as any).getGrouping() as Slick.GroupInfo<any>[] || [];
            settings['groupings'] = grouping.map(x => x.getter).filter(x => x != null && typeof x == "string");
            return settings;
        }

        protected restoreSettings(settings: Serenity.PersistedGridSettings, flags?: Serenity.GridPersistanceFlags) {
            if (settings == null) {
                if (this.options.title)
                    this.setTitle(this.options.title);

                var q = Q.parseQueryString();
                var v = q['v'];
                if (v) {
                    var storage = this.getPersistanceStorage() as Serenity.SettingStorage;
                    var key = "Views:" + this.getPersistanceKey();
                    var view = (JSON.parse(storage.getItem(key) || "{}") || {})[v];
                    if (view) {
                        settings = view;
                        this.setTitle(v);
                        this.favoriteView = view;
                    }
                }
            }

            flags = flags || this.gridPersistanceFlags();

            if (settings != null &&
                settings.columns &&
                (flags.columnWidths || Q.any(settings.columns, x => x.width != null)))
                this._disableAutoSizeColumns = true;

            flags.quickFilters = false;

            super.restoreSettings(settings, flags);

            if (settings) {
                this.paramsGrid.load(settings['params'] || {});
            }

            this.slickGrid.invalidate();
        }

        protected initialPopulate() {
            if ((this.favoriteView || this.autoRun) && this.paramsValidator.checkForm()) {
                super.initialPopulate();
            }

            if (this.options.queryType == DataQueryType.Workbook) {
                this.element.children('.grid-container').hide();
                this.element.children('.s-SlickPager').hide();
            }
        }

        protected getPersistanceKey() {
            return "DataReport:" + this.options.reportKey;
        }

        protected getViewOptions() {
            var opt = super.getViewOptions();
            opt.url = Q.resolveUrl("~/Services/Data/DataReports/ExecuteReport");
            opt.rowsPerPage = 1000;
            opt.groupItemMetadataProvider = this.groupItemMetadataProvider = new Serenity.GroupSumsMetadataProvider({});
            return opt;
        }

        protected getGridCanLoad() {
            return super.getGridCanLoad() &&
                this.paramsValidator.form();
        }

        protected onViewSubmit() {
            if (!super.onViewSubmit())
                return false;

            var request = (this.view.params as DataReportExecuteRequest);
            request.ReportKey = this.options.reportKey;
            request.Params = {};
            this.paramsGrid.save(request.Params);

            return true;
        }

        protected onViewProcessData(response) {
            response = super.onViewProcessData(response);
            var index = 0;
            for (var e of response.Entities)
                e["__$index"] = ++index;
            return response;
        }

        protected markupReady() {
            super.markupReady();

            if (this.options.expandAllGroups) {
                this.view.expandAllGroups(null);
            }

            this.autoSizeColumns();
            this.slickGrid.invalidate();
        }

        protected getButtons(): Serenity.ToolButton[] {
            var pickerButton = Serenity.ColumnPickerDialog.createToolButton(this);
            pickerButton.icon = "mdi mdi-table-column-plus-after";

            var isWorkbookReport = this.options.queryType == DataQueryType.Workbook;

            var buttons : Serenity.ToolButton[] = [{
                title: '',
                hint: 'Run report',
                cssClass: 'execute-button',
                icon: 'fa-play-circle-o text-lime',
                onClick: () => {
                    if (isWorkbookReport) {
                        if (!this.onViewSubmit()) {
                            return;
                        }

                        var data = Q.deepClone(this.view.params) as DataReportExecuteRequest;
                        DataReportsService.ExecuteReportWorkbook(
                            data,
                            response => {
                                var div = this.element.children('.spreadsheet-container');
                                if (!div.length) {
                                    div = $('<div class="spreadsheet-container"></div>');
                                    div.appendTo(this.element);
                                }
                                div.html(response.Html);
                                resizeSpreadsheet();
                                onDxFullScreenClick(resizeSpreadsheet);
                            });
                    } else {
                        this.refresh();
                    }
                }
            }, {
                title: '',
                hint: 'Export',
                cssClass: 'export-xlsx-button',
                icon: 'fa-file-excel-o',
                onClick: () => {
                    if (!this.onViewSubmit())
                        return;

                    if (isWorkbookReport) {

                        var wbReq = spreadsheet.GetSpreadsheetState();
                        wbReq.ReportKey = this.options.reportKey;

                        Q.postToService({ service: 'Data/DataReports/ExportReportWorkbook', request: wbReq, target: '_blank' });

                    } else {
                        var request = Q.deepClone(this.view.params) as DataReportExecuteRequest;
                        request.Skip = 0;
                        request.Take = 0;
                        request.IncludeColumns = [];
                        let columns = this.slickGrid.getColumns();
                        for (let column of columns) {
                            request.IncludeColumns.push(column.id || column.field);
                        }
                        request.TimeZoneOffset = -new Date().getTimezoneOffset();

                        Q.postToService({ service: 'Data/DataReports/ExecuteReportExcel', request: request, target: '_blank' });
                    }
                }
            }];

            if (!isWorkbookReport) {
                buttons.push(pickerButton);
            }

            return buttons;
        }

        protected createQuickFilters() {
            super.createQuickFilters();

            var paramsDiv = $("<form class='flex-layout params-form'>" +
                "<div class='s-Form'><div id='ReportParams'></div></div></form>")
                .insertBefore(this.quickFiltersDiv && this.quickFiltersDiv.length ?
                    this.quickFiltersDiv : this.slickContainer);

            var paramsToggleEl = $(`<i class='expand-collapse params-toggle mdi mdi-chevron-double-up' title='collapse'></i>`)
                .appendTo(this.toolbar.element);

            var paramsToggle = () => {
                var ec = paramsToggleEl.toggleClass('mdi-chevron-double-up')
                    .toggleClass('mdi-chevron-double-down');
                var collapse = ec.hasClass('mdi-chevron-double-down');
                ec.attr('title', collapse ? 'expand' : 'collapse');
                paramsDiv.children('div').toggleClass('hidden', collapse);
                localStorage.setItem('dataReportParametersCollapsed', collapse ? "1" : "0");
                $(window).triggerHandler('resize');
                this.resizeCanvas();
            };

            paramsToggleEl.click((e) => paramsToggle());

            if (localStorage.getItem("dataReportParametersCollapsed") == "1")
                paramsToggle();

            var prm = this.options.params || [];
            for (var p of prm) {
                if (p.editorParams) {
                    if (p.editorParams.minValue === '')
                        delete p.editorParams.minValue;
                    if (p.editorParams.maxValue === '')
                        delete p.editorParams.maxValue;
                }
            }

            this.paramsGrid = new Serenity.PropertyGrid(
                paramsDiv.children('div').children(), {
                    items: this.options.params || [],
                    idPrefix: this.uniqueName + '_'
                }
            );

            if (!this.options.params || !this.options.params.length) {
                paramsDiv.hide();
                paramsToggleEl.hide();
            }

            var initial = {};
            var query = Q.parseQueryString();
            for (var x of this.options.params || []) {

                var paramValue = query[x.name];
                if (x.editorType == 'Boolean') {
                    if (paramValue === undefined || paramValue === null)
                        initial[x.name] = x.defaultValue == '0' ? false : true;
                }
                if (paramValue != null) {
                    var intValue = Q.parseInteger(paramValue);
                    initial[x.name] = !isNaN(intValue) ? intValue : paramValue;
                }
            }

            this.autoRun = !!query["run"];

            this.paramsGrid.load(initial);

            if (!this.options.params || !this.options.params.length)
                this.element.find('h4.params-cap').hide();

            if (this.quickFiltersDiv && this.quickFiltersDiv.length) {
                var quickFiltersCap = $("<h4 class='quick-cap grid-sub-title'>Quick Filters<i class='expand-collapse mdi-chevron-double-up' title='collapse'></i></h4>")
                    .insertBefore(this.quickFiltersDiv);

                var quickFiltersToggle = () => {
                    var ec = quickFiltersCap.find('.expand-collapse')
                        .toggleClass('mdi-chevron-double-up').toggleClass('mdi-chevron-double-down');
                    var collapse = ec.hasClass('mdi-chevron-double-down');
                    ec.attr('title', collapse ? 'expand' : 'collapse');
                    this.quickFiltersDiv.toggleClass('hidden', collapse);
                    localStorage.setItem('dataReportQuickFiltersCollapsed', collapse ? "1" : "0");
                    $(window).triggerHandler('resize');
                    this.resizeCanvas();
                };

                quickFiltersCap.find('.expand-collapse').click((e) => quickFiltersToggle());
                if (localStorage.getItem("dataReportQuickFiltersCollapsed") == "1")
                    quickFiltersToggle();
            }

            this.paramsValidator = this.paramsGrid.element.closest('form').validate(Q.validateOptions({}));
        }

        protected getPagerOptions() {
            var opt = super.getPagerOptions();
            opt.rowsPerPageOptions = [1000, 5000, 10000, 50000];
            opt.rowsPerPage = 1000;
            return opt;
        }

        protected usePager() {
            return !this.options.hidePager;
        }

        protected getPropertyItems() {
            return this.options.columns || [];
        }

        protected createSlickGrid() {

            var grid = super.createSlickGrid();
            grid.registerPlugin(this.groupItemMetadataProvider);

            var groupingMixin = new Serenity.DraggableGroupingMixin({
                grid: this,
                displayTotalsRow: false,
            });

            groupingMixin.plugin.onGroupChanged.subscribe(() => {
                this.persistSettings(null);
                if (this.options.expandAllGroups) {
                    this.view.expandAllGroups(null);
                }
            });

            new Serenity.CustomSummaryMixin({
                grid: this
            });

            return grid;
        }

        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            opt.rowHeight = 22;
            opt.headerRowHeight = 24;
            if (!this.options.hideGrouping) {
                opt.groupingPanel = true;
                opt.groupingPanelHeight = 33;
            }

            if (!this.options.hideFooter) {
                opt.showFooterRow = true;
            }

            if (this.options.frozenColumns && this.options.frozenColumns > 0)
                opt.frozenColumn = this.options.frozenColumns - 1;

            return opt;
        }

        protected mergeTitle() {
            return true;
        }

        getItemMetadata(item: any, index: number) {
            var metadata = super.getItemMetadata(item, index);

            metadata = metadata || {};
            metadata.columns = metadata.columns || {};

            if (item._row_format_ != null) {
                if (metadata.cssClasses != null)
                    metadata.cssClasses += ' fmt-' + item._row_format_;
                else
                    metadata.cssClasses = 'fmt-' + item._row_format_
            }

            var mcols = metadata.columns;
            var cols = this.slickGrid.getColumns();
            for (var idx = 0; idx < cols.length; idx++) {
                var field = cols[idx].field;
                if (field == null)
                    continue;
                var klass = item[field + '_format_'];
                if (klass != null) {
                    klass = 'fmt-' + klass;
                    var mc = mcols[idx] = mcols[idx] || {};
                    if (mc.cssClasses != null)
                        mc.cssClasses += ' ' + klass;
                    else
                        mc.cssClasses = klass;
                }
            }

            return metadata;
        }
    }

    export interface DataReportViewGridOptions {
        title: string,
        reportKey: string,
        description: string;
        columns: Serenity.PropertyItem[],
        frozenColumns: number;
        expandAllGroups: number;
        queryType: DataQueryType;
        params: Serenity.PropertyItem[];
        hidePager?: boolean;
        hideGrouping?: boolean;
        hideFooter?: boolean;
    }

    var resizeSpreadsheet = Q.debounce(() => {
        if (typeof spreadsheet == "undefined")
            return;
        var sc = $('.spreadsheet-container');
        if (spreadsheet.isInFullScreenMode === true) {
            if (!isNaN(avail)) {
                spreadsheet.SetHeight(Math.max(250, $(document.body).outerHeight()));
                spreadsheet.SetWidth($(document.body).outerWidth());
            }
        } else {
            var grid = sc.parent();
            var avail = grid.height();
            grid.children().filter(':visible').not(sc).each(function (ix, el) {
                avail -= $(el).outerHeight(true);
            });
            if (!isNaN(avail)) {
                spreadsheet.SetHeight(Math.max(250, avail - 10));
                spreadsheet.SetWidth(grid.width());
            }
        }
    }, 10);

    var onDxFullScreenClick = (callback) => {
        if (typeof spreadsheet == "undefined")
            return;

        spreadsheet.setFullScreenModeInternal = () => {
            spreadsheet.setFullScreenModeFlag(!spreadsheet.isInFullScreen());
            spreadsheet.dsiplayControlDependingOnMode();
            callback();
        }
    }
}